// Filter Housing Products Data
export const filterHousingProducts = {
  'upvc-cartridge-filter-housing': {
    id: 'upvc-cartridge-filter-housing',
    title: 'UPVC Cartridge Style Filter Housing',
    name: 'UPVC Cartridge Style Filter Housing',
    category: 'Filter Housing',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/381587b708494aac3fe75e979c5879c5.png',
    shortDescription: 'High-precision UPVC cartridge filter housing for pretreatment and various purification applications.',
    description: 'HPCF cartridge filter is a high-precision system consisting of a housing and cartridge elements, mainly used in pretreatment for various industries.',
    longDescription: "HPCF cartridge filter is a filter system with high precision. It consists of the housing and cartridge elements, mainly used in pretreatment. It can be widely used in electronic industry, sewage treatment, beverage, foods, pure water treatment, also it can act as home water purification equipment. \n\n Note for HPCF-5DC Series: Can install 5 (or 3) cartridges with I.D. 28-30mm and O.D. 65-70mm. The highest working temperature is 45℃. The size of the two holes in the lid of the filter is G1/4\". \n\n Note for HPCF-9DC/8DC Series: Can install 9 or 8 cartridges with I.D. 28-30mm and O.D. 65-70mm. The highest working temperature is 45℃. The size of the two holes in the lid of the filter is G1/4\".",
    features: [
      'High precision filter system',
      'Consists of housing and cartridge elements',
      'Made from durable UPVC material',
      'Can install various material and precision cartridges',
      'Highest working temperature: 45℃',
      'Available in multiple sizes and configurations'
    ],
    applications: [
      'Electronic industry',
      'Sewage treatment',
      'Beverage',
      'Foods',
      'Pure water treatment',
      'Home water purification'
    ],
    specifications: {
      'Housing Material': 'UPVC',
      'Max Working Temperature': '45℃',
      'Compatible Cartridge ID': '28-30mm',
      'Compatible Cartridge OD': '65-70mm',
      'Lid Hole Size': 'G1/4"',
    },
    technicalData: {
      'HPCF-5DC Series Specifications': [
        { 'Type': 'HPCF-5DC1 / HPCF-3DC1', 'Material': 'UPVC', 'Size(mm)': 'Φ225-H465', 'Cartridges pcs': '5/3', 'Cartridges size': '10"', 'In/Out(mm)': 'DN40/ANSI 1.5" (W=365) or DN50/ANSI 2" (W=473)', 'Max pressure': 'A=0.4MPA' },
        { 'Type': 'HPCF-5DC2 / HPCF-3DC2', 'Material': 'UPVC', 'Size(mm)': 'Φ225-H715', 'Cartridges pcs': '5/3', 'Cartridges size': '20"', 'In/Out(mm)': 'DN40/ANSI 1.5" (W=365) or DN50/ANSI 2" (W=473)', 'Max pressure': 'B=0.6MPA' },
        { 'Type': 'HPCF-5DC3 / HPCF-3DC3', 'Material': 'UPVC', 'Size(mm)': 'Φ225-H965', 'Cartridges pcs': '5/3', 'Cartridges size': '30"', 'In/Out(mm)': 'DN40/ANSI 1.5" (W=365) or DN50/ANSI 2" (W=473)', 'Max pressure': 'B=0.6MPA' },
        { 'Type': 'HPCF-5DC4 / HPCF-3DC4', 'Material': 'UPVC', 'Size(mm)': 'Φ225-H1215', 'Cartridges pcs': '5/3', 'Cartridges size': '40"', 'In/Out(mm)': 'DN40/ANSI 1.5" (W=365) or DN50/ANSI 2" (W=473)', 'Max pressure': 'B=0.6MPA' },
      ],
      'HPCF-9DC / 8DC Series Specifications': [
        { 'Model': 'HPCF-9DC1 / HPCF-8DC1', 'Material': 'UPVC', 'Size(mm)': 'Φ315-H495', 'Cartridges Pcs': '9/8', 'Cartridges Size': '10"', 'In/Out(mm)': 'DN80/ANSI 3"', 'Drainer(mm)': 'DIN1/2" or ANSI1/2"', 'Max Pressure': '0.6Mpa(86PSI)' },
        { 'Model': 'HPCF-9DC2 / HPCF-8DC2', 'Material': 'UPVC', 'Size(mm)': 'Φ315-H745', 'Cartridges Pcs': '9/8', 'Cartridges Size': '20"', 'In/Out(mm)': 'DN80/ANSI 3"', 'Drainer(mm)': 'DIN1/2" or ANSI1/2"', 'Max Pressure': '0.6Mpa(86PSI)' },
        { 'Model': 'HPCF-9DC3 / HPCF-8DC3', 'Material': 'UPVC', 'Size(mm)': 'Φ315-H995', 'Cartridges Pcs': '9/8', 'Cartridges Size': '30"', 'In/Out(mm)': 'DN80/ANSI 3"', 'Drainer(mm)': 'DIN1/2" or ANSI1/2"', 'Max Pressure': '0.6Mpa(86PSI)' },
        { 'Model': 'HPCF-9DC4 / HPCF-8DC4', 'Material': 'UPVC', 'Size(mm)': 'Φ315-H1245', 'Cartridges Pcs': '9/8', 'Cartridges Size': '40"', 'In/Out(mm)': 'DN80/ANSI 3"', 'Drainer(mm)': 'DIN1/2" or ANSI1/2"', 'Max Pressure': '0.6Mpa(86PSI)' },
      ],
    }
  },
  'upvc-bag-style-filter-housing': {
    id: 'upvc-bag-style-filter-housing',
    title: 'UPVC Bag Style Filter Housing',
    name: 'UPVC Bag Style Filter Housing',
    category: 'Filter Housing',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/83ca33c40581e3462acceed8f4ceaf1d.png',
    shortDescription: 'High precision, big flow UPVC bag filter system for various liquid treatment applications.',
    description: 'A new filter system with high precision, big flow, easy installation and maintenance, widely used in liquid treatment.',
    longDescription: "UPVC bag filter system is a new filter systerm. It is character with high precision,big flow,easy installation and maintenance.So it can be widely used in the field of liquid treatment:foods,cosmetic,chemistry,medicine,textile,etc.It consists of the housing,support basket,and the filter bag.\n\nNote: It can install all material,all precison’s filter bag 1PCS. The highest of working temperature is 45℃,The size of the two holes in the lid of the filter is G1/4〞",
    features: [
      'High precision filtration',
      'High flow rate',
      'Easy installation and maintenance',
      'Consists of housing, support basket, and filter bag',
      'Durable UPVC construction',
      'Accommodates a single filter bag of any material and precision'
    ],
    applications: [
      'Foods',
      'Cosmetic',
      'Chemistry',
      'Medicine',
      'Textile',
      'General liquid treatment'
    ],
    specifications: {
      'Housing Material': 'UPVC',
      'Compatible Bags': '1 PCS of any material/precision',
      'Max Working Temperature': '45℃',
      'Lid Hole Size': 'G1/4〞'
    },
    technicalData: {
      'Model Specifications': [
        { 'Model': 'BF-1-1-A', 'Size(mm)': 'Φ225-H785', 'Bag Size': 'Φ7"(178mm)-H17"(419mm)', 'Inlet/Outlet(mm)': 'Flange: DN50/ANSI2"', 'Insert Height': '630', 'Max Pressure': 'A=0.4Mpa' },
        { 'Model': 'BF-1-2-A', 'Size(mm)': 'Φ225-H1180', 'Bag Size': 'Φ7"(178mm)-H32"(813mm)', 'Inlet/Outlet(mm)': 'Flange: DN50/ANSI2"', 'Insert Height': '1050', 'Max Pressure': 'A=0.4Mpa' },
        { 'Model': 'BF-1-1-B', 'Size(mm)': 'Φ225-H820', 'Bag Size': 'Φ7"(178mm)-H17"(419mm)', 'Inlet/Outlet(mm)': 'Flange: DN50/ANSI2"', 'Insert Height': '665', 'Max Pressure': 'B=0.7Mpa' },
        { 'Model': 'BF-1-2-B', 'Size(mm)': 'Φ225-H1200', 'Bag Size': 'Φ7"(178mm)-H32"(813mm)', 'Inlet/Outlet(mm)': 'Flange: DN50/ANSI2"', 'Insert Height': '1045', 'Max Pressure': 'B=0.7Mpa' }
      ]
    }
  },
  'ss-ultra-highflow-cartridge-filter-housing': {
    id: 'ss-ultra-highflow-cartridge-filter-housing',
    title: 'SS Ultra Highflow Cartridge Filter Housing',
    name: 'SS Ultra Highflow Cartridge Filter Housing',
    category: 'Filter Housing',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/d29cd93ad166a272bea6e7bf3929d965.jpg',
    shortDescription: 'Heavy-duty stainless steel housing for ultra highflow cartridges with swing bolt closure.',
    description: 'The HCFH-SERIES is a robust stainless steel filter housing designed for high-flow applications, featuring a swing bolt hinged closure for easy access.',
    longDescription: 'The HCFH-SERIES ultra highflow cartridge filter housing is constructed from high-quality stainless steel (304# or 316L) for maximum durability and chemical compatibility. It features a user-friendly swing bolt hinged cover for quick cartridge change-outs and a secure seal. With a maximum pressure rating of 150 psi and options for polished or sandblasted outer surfaces, it is ideal for demanding industrial filtration tasks.',
    features: [
        'Material: Stainless Steel 304# or 316L',
        'Cover opening & closure type: Swing bolt hinged',
        'Max. pressure: 150psi',
        'Outer surface: Polished or Sandblast',
        'Designed for highflow cartridges',
        'Robust and durable construction'
    ],
    applications: [
        'Industrial water treatment',
        'Chemical processing',
        'Food and beverage',
        'RO pre-filtration',
        'Wastewater treatment'
    ],
    specifications: {
      'Housing Material': 'Stainless Steel 304#, 316L',
      'Closure Type': 'Swing bolt hinged',
      'Max Pressure': '150psi',
      'Surface Finish': 'Polished or Sandblast'
    },
    technicalData: {
      'Ordering Guide': [
        { 'Model': '1 Round - 40"L', 'A (mm)': '350', 'B (mm)': '530', 'C (mm)': '1270', 'D (mm)': '200', 'Inlet/Outlet': '2"-3"', 'Drain': '1/2"' },
        { 'Model': '2 Round - 40"L', 'A (mm)': '500', 'B (mm)': '960', 'C (mm)': '1670', 'D (mm)': '450', 'Inlet/Outlet': '3"-4"', 'Drain': '1"' },
        { 'Model': '3 Round - 40"L', 'A (mm)': '580', 'B (mm)': '1070', 'C (mm)': '1810', 'D (mm)': '500', 'Inlet/Outlet': '4"-6"', 'Drain': '1"' },
        { 'Model': '4 Round - 40"L', 'A (mm)': '610', 'B (mm)': '1125', 'C (mm)': '1835', 'D (mm)': '550', 'Inlet/Outlet': '5"-6"', 'Drain': '1"' }
      ]
    }
  },
  'ss-cartridge-style-filter-housing-cfh-3': {
    id: 'ss-cartridge-style-filter-housing-cfh-3',
    title: 'SS Cartridge Style Filter Housing CFH-3',
    name: 'SS Cartridge Style Filter Housing CFH-3',
    category: 'Filter Housing',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/3a39b1a5fd337868181b66e8310fdea4.png',
    shortDescription: 'Industrial stainless steel filter housing with swing bolt closure and lifting davit for heavy-duty applications.',
    description: 'The CFH-3 Series is an industrial-grade stainless steel cartridge filter housing featuring a swing bolt hinged closure with a lifting davit, designed for easy maintenance and secure operation in high-demand environments.',
    longDescription: 'This Stainless Steel Industry Cartridge Style Filter Housing from the CFH-3 series is built for robustness and ease of use. Constructed from high-quality 304# or 316L stainless steel, it is designed to withstand demanding industrial conditions. The cover features a swing bolt hinged mechanism with a lifting davit, simplifying the process of opening and closing for cartridge replacement. It supports both 222 o-ring/fin and Double Open End (DOE) filter element adaptors, offering flexibility for various filtration needs with a maximum pressure of 150psi.',
    features: [
      'Material: Stainless steel 304#, 316L',
      'Cover opening & closure type: Swing bolt hinged with lifting davit',
      'Max. pressure: 150psi',
      'Filter elements adaptor: 222 o-ring/fin, Double open end-DOE',
      'Heavy-duty industrial design',
      'Lifting davit for easy cover handling'
    ],
    applications: [
      'Industrial water treatment',
      'Chemical Processing',
      'Food and Beverage',
      'RO Pre-filtration',
      'Pharmaceuticals',
      'Wastewater Treatment'
    ],
    specifications: {
      'Housing Material': 'Stainless Steel 304#, 316L',
      'Closure Type': 'Swing bolt hinged with lifting davit',
      'Max Pressure': '150psi',
      'Filter Adaptors': '222 o-ring/fin, Double open end-DOE'
    },
    technicalData: {
      'Model Specifications': [
        { 'Model': '15 Round - 30"L', 'A (mm)': 370, 'B (mm)': 800, 'C (mm)': 1580, 'D (mm)': 350, 'E (mm)': 350, 'F (mm)': 200, 'H (mm)': 490, 'Inlet/Outlet': '1 1/2"-2"' },
        { 'Model': '15 Round - 40"L', 'A (mm)': 370, 'B (mm)': 900, 'C (mm)': 1830, 'D (mm)': 350, 'E (mm)': 350, 'F (mm)': 200, 'H (mm)': 490, 'Inlet/Outlet': '1 1/2"-2"' },
        { 'Model': '20 Round - 30"L', 'A (mm)': 390, 'B (mm)': 900, 'C (mm)': 1630, 'D (mm)': 400, 'E (mm)': 400, 'F (mm)': 200, 'H (mm)': 560, 'Inlet/Outlet': '2"-3"' },
        { 'Model': '20 Round - 40"L', 'A (mm)': 390, 'B (mm)': 1000, 'C (mm)': 1880, 'D (mm)': 400, 'E (mm)': 400, 'F (mm)': 200, 'H (mm)': 560, 'Inlet/Outlet': '2"-3"' },
        { 'Model': '27 Round - 30"L', 'A (mm)': 460, 'B (mm)': 900, 'C (mm)': 1680, 'D (mm)': 450, 'E (mm)': 450, 'F (mm)': 250, 'H (mm)': 610, 'Inlet/Outlet': '2"-4"' },
        { 'Model': '27 Round - 40"L', 'A (mm)': 460, 'B (mm)': 1100, 'C (mm)': 1930, 'D (mm)': 450, 'E (mm)': 450, 'F (mm)': 250, 'H (mm)': 610, 'Inlet/Outlet': '2"-4"' },
        { 'Model': '30 Round - 30"L', 'A (mm)': 480, 'B (mm)': 900, 'C (mm)': 1740, 'D (mm)': 500, 'E (mm)': 500, 'F (mm)': 250, 'H (mm)': 660, 'Inlet/Outlet': '2"-4"' },
        { 'Model': '30 Round - 40"L', 'A (mm)': 480, 'B (mm)': 1100, 'C (mm)': 1990, 'D (mm)': 500, 'E (mm)': 500, 'F (mm)': 250, 'H (mm)': 660, 'Inlet/Outlet': '2"-4"' },
        { 'Model': '36 Round - 30"L', 'A (mm)': 500, 'B (mm)': 900, 'C (mm)': 1780, 'D (mm)': 550, 'E (mm)': 550, 'F (mm)': 250, 'H (mm)': 710, 'Inlet/Outlet': '2 1/2"-4"' },
        { 'Model': '36 Round - 40"L', 'A (mm)': 500, 'B (mm)': 1100, 'C (mm)': 2030, 'D (mm)': 550, 'E (mm)': 550, 'F (mm)': 250, 'H (mm)': 710, 'Inlet/Outlet': '2 1/2"-4"' },
        { 'Model': '40 Round - 30"L', 'A (mm)': 560, 'B (mm)': 1000, 'C (mm)': 1850, 'D (mm)': 600, 'E (mm)': 600, 'F (mm)': 300, 'H (mm)': 760, 'Inlet/Outlet': '2 1/2"-4"' },
        { 'Model': '40 Round - 40"L', 'A (mm)': 560, 'B (mm)': 1200, 'C (mm)': 2100, 'D (mm)': 600, 'E (mm)': 600, 'F (mm)': 300, 'H (mm)': 760, 'Inlet/Outlet': '2 1/2"-4"' },
        { 'Model': '50 Round - 30"L', 'A (mm)': 580, 'B (mm)': 1000, 'C (mm)': 1880, 'D (mm)': 650, 'E (mm)': 650, 'F (mm)': 300, 'H (mm)': 810, 'Inlet/Outlet': '3"-4"' },
        { 'Model': '50 Round - 40"L', 'A (mm)': 580, 'B (mm)': 1200, 'C (mm)': 2130, 'D (mm)': 650, 'E (mm)': 650, 'F (mm)': 300, 'H (mm)': 810, 'Inlet/Outlet': '3"-4"' },
        { 'Model': '60 Round - 30"L', 'A (mm)': 590, 'B (mm)': 1000, 'C (mm)': 1900, 'D (mm)': 700, 'E (mm)': 700, 'F (mm)': 300, 'H (mm)': 880, 'Inlet/Outlet': '3"-5"' },
        { 'Model': '60 Round - 40"L', 'A (mm)': 590, 'B (mm)': 1200, 'C (mm)': 2150, 'D (mm)': 700, 'E (mm)': 700, 'F (mm)': 300, 'H (mm)': 880, 'Inlet/Outlet': '3"-5"' },
        { 'Model': '75 Round - 30"L', 'A (mm)': 610, 'B (mm)': 1000, 'C (mm)': 1950, 'D (mm)': 750, 'E (mm)': 750, 'F (mm)': 300, 'H (mm)': 950, 'Inlet/Outlet': '3"-5"' },
        { 'Model': '75 Round - 40"L', 'A (mm)': 610, 'B (mm)': 1250, 'C (mm)': 2200, 'D (mm)': 750, 'E (mm)': 750, 'F (mm)': 300, 'H (mm)': 950, 'Inlet/Outlet': '3"-5"' },
        { 'Model': '80 Round - 30"L', 'A (mm)': 620, 'B (mm)': 1100, 'C (mm)': 1970, 'D (mm)': 800, 'E (mm)': 800, 'F (mm)': 300, 'H (mm)': 1000, 'Inlet/Outlet': '4"-6"' },
        { 'Model': '80 Round - 40"L', 'A (mm)': 620, 'B (mm)': 1250, 'C (mm)': 2220, 'D (mm)': 800, 'E (mm)': 800, 'F (mm)': 300, 'H (mm)': 1000, 'Inlet/Outlet': '4"-6"' },
        { 'Model': '90 Round - 30"L', 'A (mm)': 650, 'B (mm)': 1100, 'C (mm)': 2140, 'D (mm)': 850, 'E (mm)': 850, 'F (mm)': 300, 'H (mm)': 1000, 'Inlet/Outlet': '4"-6"' },
        { 'Model': '90 Round - 40"L', 'A (mm)': 650, 'B (mm)': 1250, 'C (mm)': 2390, 'D (mm)': 850, 'E (mm)': 850, 'F (mm)': 300, 'H (mm)': 1000, 'Inlet/Outlet': '4"-6"' },
        { 'Model': '100 Round - 30"L', 'A (mm)': 670, 'B (mm)': 1100, 'C (mm)': 2070, 'D (mm)': 900, 'E (mm)': 900, 'F (mm)': 300, 'H (mm)': 1140, 'Inlet/Outlet': '4"-6"' },
        { 'Model': '100 Round - 40"L', 'A (mm)': 670, 'B (mm)': 1350, 'C (mm)': 2320, 'D (mm)': 900, 'E (mm)': 900, 'F (mm)': 300, 'H (mm)': 1140, 'Inlet/Outlet': '4"-6"' }
      ]
    }
  },
  'ss-cartridge-style-filter-housing-cfh-2': {
    id: 'ss-cartridge-style-filter-housing-cfh-2',
    title: 'SS Cartridge Style Filter Housing CFH-2',
    name: 'SS Cartridge Style Filter Housing CFH-2',
    category: 'Filter Housing',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/778313498601fa73d02b1640fa48b800.png',
    shortDescription: 'Industrial stainless steel housing (CFH-2 series) for cartridge filters with a swing bolt closure.',
    description: 'The CFH-2 Series is a durable stainless steel cartridge filter housing featuring a convenient swing bolt hinged closure, designed for industrial filtration applications.',
    longDescription: 'This Stainless Steel Industry Cartridge Style Filter Housing from the CFH-2 series is engineered for reliability and ease of use in industrial settings. Constructed from high-quality 304# or 316L stainless steel, it ensures excellent chemical compatibility and longevity. The cover features a swing bolt hinged mechanism for quick and easy access during cartridge replacement. It accommodates both 222 o-ring/fin and Double Open End (DOE) filter element adaptors, providing flexibility for various filtration requirements with a maximum pressure rating of 150psi.',
    features: [
      'Material: Stainless steel 304#, 316L',
      'Cover opening & closure type: Swing bolt hinged',
      'Max. pressure: 150psi',
      'Filter elements adaptor: 222 o-ring/fin, Double open end-DOE',
      'Durable industrial design for various applications'
    ],
    applications: [
      'Industrial water treatment',
      'Chemical Processing',
      'Food and Beverage',
      'RO Pre-filtration',
      'Wastewater Treatment'
    ],
    specifications: {
      'Housing Material': 'Stainless Steel 304#, 316L',
      'Closure Type': 'Swing bolt hinged',
      'Max Pressure': '150psi',
      'Filter Adaptors': '222 o-ring/fin, Double open end-DOE'
    },
    technicalData: {
      'Model Specifications': [
        { 'Model': '5 Round - 30"L', 'A mm': 250, 'B mm': 600, 'C mm': 1250, 'D mm': 200, 'E mm': 200, 'F mm': 120, 'H mm': 340, 'Inlet/Outlet': '1 1/2"-2"' },
        { 'Model': '5 Round - 40"L', 'A mm': 250, 'B mm': 700, 'C mm': 1500, 'D mm': 200, 'E mm': 200, 'F mm': 120, 'H mm': 340, 'Inlet/Outlet': '1 1/2"-2"' },
        { 'Model': '7 Round - 30"L', 'A mm': 300, 'B mm': 700, 'C mm': 1300, 'D mm': 250, 'E mm': 250, 'F mm': 150, 'H mm': 390, 'Inlet/Outlet': '1 1/2"-2"' },
        { 'Model': '7 Round - 40"L', 'A mm': 300, 'B mm': 800, 'C mm': 1550, 'D mm': 250, 'E mm': 250, 'F mm': 150, 'H mm': 390, 'Inlet/Outlet': '1 1/2"-2"' },
        { 'Model': '11 Round - 30"L', 'A mm': 360, 'B mm': 700, 'C mm': 1380, 'D mm': 300, 'E mm': 300, 'F mm': 200, 'H mm': 440, 'Inlet/Outlet': '2"-3"' },
        { 'Model': '11 Round - 40"L', 'A mm': 360, 'B mm': 900, 'C mm': 1620, 'D mm': 300, 'E mm': 300, 'F mm': 200, 'H mm': 440, 'Inlet/Outlet': '2"-3"' },
        { 'Model': '15 Round - 30"L', 'A mm': 380, 'B mm': 800, 'C mm': 1420, 'D mm': 350, 'E mm': 350, 'F mm': 200, 'H mm': 530, 'Inlet/Outlet': '2"-3"' },
        { 'Model': '15 Round - 40"L', 'A mm': 380, 'B mm': 900, 'C mm': 1660, 'D mm': 350, 'E mm': 350, 'F mm': 200, 'H mm': 530, 'Inlet/Outlet': '2"-3"' },
        { 'Model': '20 Round - 30"L', 'A mm': 400, 'B mm': 800, 'C mm': 1460, 'D mm': 400, 'E mm': 400, 'F mm': 200, 'H mm': 560, 'Inlet/Outlet': '2"-4"' },
        { 'Model': '20 Round - 40"L', 'A mm': 400, 'B mm': 900, 'C mm': 1700, 'D mm': 400, 'E mm': 400, 'F mm': 200, 'H mm': 560, 'Inlet/Outlet': '2"-4"' },
        { 'Model': '27 Round - 30"L', 'A mm': 460, 'B mm': 800, 'C mm': 1530, 'D mm': 450, 'E mm': 450, 'F mm': 250, 'H mm': 630, 'Inlet/Outlet': '2"-4"' },
        { 'Model': '27 Round - 40"L', 'A mm': 460, 'B mm': 1000, 'C mm': 1770, 'D mm': 450, 'E mm': 450, 'F mm': 250, 'H mm': 630, 'Inlet/Outlet': '2"-4"' }
      ]
    }
  },
  'ss-cartridge-style-filter-housing-cfh-1': {
    id: 'ss-cartridge-style-filter-housing-cfh-1',
    title: 'SS Cartridge Style Filter Housing CFH-1',
    name: 'SS Cartridge Style Filter Housing CFH-1',
    category: 'Filter Housing',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/77a09ce56b225e6e6efafb9a9beea747.jpg',
    shortDescription: 'Light-duty stainless steel housing (CFH-1 series) for cartridge filters with a V-clamp closure.',
    description: 'The CFH-1 Series is a stainless steel cartridge filter housing featuring a V-clamp hinged closure, designed for light-duty industrial and commercial filtration applications.',
    longDescription: 'This Stainless Steel Industry Cartridge Style Filter Housing from the CFH-1 series is designed for ease of use and reliability. Constructed from high-quality 304# or 316L stainless steel, it offers good performance for a variety of filtration tasks. The cover features a simple and secure V-clamp hinged mechanism for quick cartridge replacement. It accommodates both 222 o-ring/fin and Double Open End (DOE) filter element adaptors and is rated for a maximum pressure of 100psi, making it suitable for less demanding applications.',
    features: [
      'Material: Stainless steel 304#, 316L',
      'Cover opening & closure type: V-clamp hinged',
      'Max. pressure: 100psi',
      'Filter elements adaptor: 222 o-ring/fin, Double open end-DOE',
      'Economical design for light-duty applications'
    ],
    applications: [
      'General water filtration',
      'RO Pre-filtration',
      'Food and Beverage',
      'Light industrial water treatment'
    ],
    specifications: {
      'Housing Material': 'Stainless Steel 304#, 316L',
      'Closure Type': 'V-clamp hinged',
      'Max Pressure': '100psi',
      'Filter Adaptors': '222 o-ring/fin, Double open end-DOE'
    },
    technicalData: {
      'Model Specifications': [
        { 'Model': '3 Round - 10"L', 'A mm': 75, 'B mm': 180, 'C mm': 550, 'D mm': 170, 'E mm': 216, 'F mm': 230, 'Inlet/Outlet': '1"-1 1/2"' },
        { 'Model': '3 Round - 20"L', 'A mm': 75, 'B mm': 180, 'C mm': 800, 'D mm': 170, 'E mm': 216, 'F mm': 230, 'Inlet/Outlet': '1"-1 1/2"' },
        { 'Model': '3 Round - 30"L', 'A mm': 75, 'B mm': 180, 'C mm': 1050, 'D mm': 170, 'E mm': 216, 'F mm': 230, 'Inlet/Outlet': '1"-2"' },
        { 'Model': '3 Round - 40"L', 'A mm': 75, 'B mm': 180, 'C mm': 1300, 'D mm': 170, 'E mm': 216, 'F mm': 230, 'Inlet/Outlet': '1"-2"' },
        { 'Model': '5 Round - 10"L', 'A mm': 75, 'B mm': 180, 'C mm': 560, 'D mm': 200, 'E mm': 248, 'F mm': 260, 'Inlet/Outlet': '1"-1 1/2"' },
        { 'Model': '5 Round - 20"L', 'A mm': 75, 'B mm': 180, 'C mm': 810, 'D mm': 200, 'E mm': 248, 'F mm': 260, 'Inlet/Outlet': '1"-1 1/2"' },
        { 'Model': '5 Round - 30"L', 'A mm': 75, 'B mm': 180, 'C mm': 1060, 'D mm': 200, 'E mm': 248, 'F mm': 260, 'Inlet/Outlet': '1"-2"' },
        { 'Model': '5 Round - 40"L', 'A mm': 120, 'B mm': 220, 'C mm': 1360, 'D mm': 200, 'E mm': 248, 'F mm': 260, 'Inlet/Outlet': '1"-2"' },
        { 'Model': '7 Round - 10"L', 'A mm': 120, 'B mm': 220, 'C mm': 620, 'D mm': 250, 'E mm': 310, 'F mm': 315, 'Inlet/Outlet': '1 1/2"-2"' },
        { 'Model': '7 Round - 20"L', 'A mm': 120, 'B mm': 220, 'C mm': 870, 'D mm': 250, 'E mm': 310, 'F mm': 315, 'Inlet/Outlet': '1 1/2"-2"' },
        { 'Model': '7 Round - 30"L', 'A mm': 120, 'B mm': 220, 'C mm': 1120, 'D mm': 250, 'E mm': 310, 'F mm': 315, 'Inlet/Outlet': '2"-2 1/2"' },
        { 'Model': '7 Round - 40"L', 'A mm': 120, 'B mm': 220, 'C mm': 1370, 'D mm': 250, 'E mm': 310, 'F mm': 315, 'Inlet/Outlet': '2"-2 1/2"' }
      ]
    }
  },
    'ss-single-bag-style-filter-housing-sbf-2': {
    id: 'ss-single-bag-style-filter-housing-sbf-2',
    title: 'SS Single Bag Style Filter Housing SBF-2',
    name: 'SS Single Bag Style Filter Housing SBF-2',
    category: 'Filter Housing',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/5dd111ce87360dabf22cdc87f38c720c.png',
    shortDescription: 'Stainless steel single-bag filter housing (SBF-2 series) for industrial liquid treatment; swing-bolt cover, max 150psi.',
    description: 'Stainless Steel Industry Bag Style Filter Housing — SBF-2 Series (Single Bag).',
    longDescription: `SBF-2 Series single-bag stainless steel filter housing designed for industrial liquid treatment. Material: Stainless Steel 304# or 316L. Cover opening & closure type: Swing bolt hinged. Max Pressure: 150psi. Suitable for chemical processing, food & beverage, pharmaceutical and general industrial water treatment applications.`,
    features: [
      'Material: Stainless Steel 304# or 316L',
      'Single bag configuration',
      'Swing bolt hinged cover',
      'Max Pressure: 150psi',
      'Robust construction for easy maintenance and bag replacement'
    ],
    applications: [
      'Industrial water treatment',
      'Chemical processing',
      'Food and beverage',
      'Pharmaceuticals',
      'General liquid treatment'
    ],
    specifications: {
      'Housing Material': 'Stainless Steel 304#, 316L',
      'Configuration': 'Single Bag',
      'Closure Type': 'Swing bolt hinged',
      'Max Pressure': '150psi'
    },
    technicalData: {
      'Model Specifications': [
        { 'Model': 'Single Bag size#1', 'A mm': '500', 'B mm': '380', 'C mm': '720', 'D mm': '219', 'F mm': '170', 'Inlet/Outlet': '1\"-4\"' },
        { 'Model': 'Single Bag size#2', 'A mm': '700', 'B mm': '720', 'C mm': '1070', 'D mm': '219', 'F mm': '170', 'Inlet/Outlet': '1\"-4\"' },
        { 'Model': 'Single Bag size#3', 'A mm': '350', 'B mm': '190', 'C mm': '430', 'D mm': '114', 'F mm': '97',  'Inlet/Outlet': '3/4\"-2\"' },
        { 'Model': 'Single Bag size#4', 'A mm': '500', 'B mm': '340', 'C mm': '580', 'D mm': '114', 'F mm': '97',  'Inlet/Outlet': '3/4\"-2\"' }
      ]
    }
  },
    'ss-single-bag-style-filter-housing-sbf-1': {
    id: 'ss-single-bag-style-filter-housing-sbf-1',
    title: 'SS Single Bag Style Filter Housing SBF-1',
    name: 'SS Single Bag Style Filter Housing SBF-1',
    category: 'Filter Housing',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/db31dc436950b6d90c726517bbb5ef7d.png',
    shortDescription: 'Stainless steel single-bag filter housing (SBF-1 series) for industrial liquid treatment; V-clamp hinged cover, max 100psi.',
    description: 'Stainless Steel Industry Bag Style Filter Housing — SBF-1 Series (Single Bag).',
    longDescription: `SBF-1 Series single-bag stainless steel filter housing designed for industrial liquid treatment.
Material: Stainless Steel 304# or 316L.
Cover opening & closure type: V-clamp hinged.
Max Pressure: 100psi.
Suitable for chemical processing, food & beverage, pharmaceutical and general industrial water treatment applications.`,
    features: [
      'Material: Stainless Steel 304# or 316L',
      'Single bag configuration',
      'V-clamp hinged cover for quick access',
      'Max Pressure: 100psi',
      'Robust construction for easy maintenance and bag replacement'
    ],
    applications: [
      'Industrial water treatment',
      'Chemical processing',
      'Food and beverage',
      'Pharmaceuticals',
      'General liquid treatment'
    ],
    specifications: {
      'Housing Material': 'Stainless Steel 304#, 316L',
      'Configuration': 'Single Bag',
      'Closure Type': 'V-clamp hinged',
      'Max Pressure': '100psi'
    },
    technicalData: {
      'Model Specifications': [
        { 'Model': 'Single Bag size#1', 'A mm': '500', 'B mm': '380', 'C mm': '700', 'D mm': '200', 'F mm': '170', 'Inlet/Outlet': '1\"-4\"' },
        { 'Model': 'Single Bag size#2', 'A mm': '700', 'B mm': '720', 'C mm': '1050', 'D mm': '200', 'F mm': '170', 'Inlet/Outlet': '1\"-4\"' },
        { 'Model': 'Single Bag size#3', 'A mm': '350', 'B mm': '190', 'C mm': '400', 'D mm': '114', 'F mm': '97',  'Inlet/Outlet': '3/4\"-2\"' },
        { 'Model': 'Single Bag size#4', 'A mm': '500', 'B mm': '340', 'C mm': '540', 'D mm': '114', 'F mm': '97',  'Inlet/Outlet': '3/4\"-2\"' }
      ]
    }
  },
    'ss-multi-bag-style-filter-housing-mbf': {
    id: 'ss-multi-bag-style-filter-housing-mbf',
    title: 'SS Multi Bag Style Filter Housing MBF',
    name: 'SS Multi Bag Style Filter Housing MBF',
    category: 'Filter Housing',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/c47d87df9b1837948cecdcc6a3c6fce3.png',
    shortDescription: 'Stainless steel multi-bag filter housing (MBF series) for high-flow industrial liquid treatment; swing-bolt cover with lifting davit, max 150psi.',
    description: 'Stainless Steel Industry Bag Style Filter Housing — MBF Series (Multi Bag).',
    longDescription: `MBF Series multi-bag stainless steel filter housing designed for high-flow industrial liquid treatment.
Material: Stainless Steel 304# or 316L.
Series: MBF — Multi Bag Style.
Cover opening & closure type: Swing bolt hinged with lifting davit.
Max Pressure: 150psi.
Introduction & datasheet: https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/dfd16073f613a01ab579b19c9bf533b0.png
Suitable for chemical processing, food & beverage, pharmaceutical and large-scale industrial water treatment applications.`,
    features: [
      'Material: Stainless Steel 304# or 316L',
      'Multi-bag configuration for high flow',
      'Swing bolt hinged cover with lifting davit',
      'Max Pressure: 150psi',
      'Robust construction for easy maintenance and bag replacement'
    ],
    applications: [
      'Industrial water treatment',
      'Chemical processing',
      'Food and beverage',
      'Pharmaceuticals',
      'Large-scale liquid treatment'
    ],
    specifications: {
      'Housing Material': 'Stainless Steel 304#, 316L',
      'Configuration': 'Multi Bag',
      'Closure Type': 'Swing bolt hinged with lifting davit',
      'Max Pressure': '150psi'
    },
    technicalData: {
      'Model Specifications': [
        { 'Model': '2 Bag size#2',  'A mm': '108', 'B mm': '1100', 'C mm': '1430', 'D mm': '450', 'E mm': '450', 'F mm': '590',  'H mm': '590',  'Inlet/Outlet': '3\"' },
        { 'Model': '3 Bag size#2',  'A mm': '150', 'B mm': '1190', 'C mm': '1540', 'D mm': '500', 'E mm': '500', 'F mm': '640',  'H mm': '640',  'Inlet/Outlet': '4\"' },
        { 'Model': '4 Bag size#2',  'A mm': '150', 'B mm': '1200', 'C mm': '1560', 'D mm': '550', 'E mm': '550', 'F mm': '690',  'H mm': '690',  'Inlet/Outlet': '4\"' },
        { 'Model': '5 Bag size#2',  'A mm': '150', 'B mm': '1250', 'C mm': '1630', 'D mm': '600', 'E mm': '600', 'F mm': '740',  'H mm': '760',  'Inlet/Outlet': '5\"' },
        { 'Model': '6 Bag size#2',  'A mm': '200', 'B mm': '1380', 'C mm': '1780', 'D mm': '700', 'E mm': '700', 'F mm': '840',  'H mm': '860',  'Inlet/Outlet': '6\"' },
        { 'Model': '8 Bag size#2',  'A mm': '200', 'B mm': '1460', 'C mm': '1920', 'D mm': '750', 'E mm': '750', 'F mm': '910',  'H mm': '930',  'Inlet/Outlet': '8\"' },
        { 'Model': '9 Bag size#2',  'A mm': '200', 'B mm': '1470', 'C mm': '1950', 'D mm': '800', 'E mm': '800', 'F mm': '960',  'H mm': '980',  'Inlet/Outlet': '8\"' },
        { 'Model': '10 Bag size#2', 'A mm': '250', 'B mm': '1550', 'C mm': '2050', 'D mm': '900', 'E mm': '900', 'F mm': '1060', 'H mm': '1100', 'Inlet/Outlet': '8\"' }
      ]
    }
  },
    'household-plastic-filter-housing': {
    id: 'household-plastic-filter-housing',
    title: 'Household Plastic Filter Housing',
    name: 'Household Plastic Filter Housing',
    category: 'Filter Housing',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/cecb80a7bc5bc594b571fbcacd83a479.png',
    shortDescription: 'Household plastic filter housings in multiple styles; high-quality PP/AS materials, multiple port sizes and options.',
    description: 'Household Plastic Filter Housing — multiple styles and models for residential filtration systems.',
    longDescription: `Household Plastic Filter Housing made from high quality PP and AS materials in conformity with FDA standards. Available in multiple styles (Style No.1 to No.4) with various port sizes and options such as opener, air release button, and brass thread insert. Thicker housing and rib design increase pressure resistance and durability.

Technical specifications:
- Max. Pressure: 8 Bar (115psi)
- Failure Test Pressure: 30 Bar (435psi)
- Cycle Test: 0-115psi, 100000 cycles
- Recommended Pressure: < 6 Bar (88psi) at 25°C
- Max. Temperature: 50°C
- Flow rate and pressure loss depend on filter element type

Warning: Do not expose filter housing to direct sunlight.`,
    features: [
      'High quality PP and AS materials (FDA compliant)',
      'Thicker housing with rib design for increased strength',
      'Options: opener, air release button, brass thread insert',
      'Multiple port sizes available',
      'Durable and reliable for household filtration'
    ],
    applications: [
      'Domestic water filtration',
      'Drinking water systems',
      'Pre-filtration for RO systems',
      'Small commercial water filtration'
    ],
    specifications: {
      'Housing Material': 'PP, AS (FDA compliant)',
      'Max Pressure': '8 Bar (115psi)',
      'Failure Test Pressure': '30 Bar (435psi)',
      'Cycle Test': '0-115psi, 100000 cycles',
      'Recommended Pressure': '< 6 Bar (88psi) at 25°C',
      'Max Temperature': '50°C',
      'Inlet/Outlet Thread': 'Plastic, brass insert'
    },
    technicalData: {
      'Styles & Models': [
        {
          'Style': 'Style No.1',
          'Models': ['FH-10A1', 'FH-10A2', 'FH-10B1', 'FH-10B2', 'FH-5A2'],
          'Inlet/Outlet Thread': 'Plastic, brass insert',
          'Port Sizes': ['1/4"', '1/2"', '3/4"']
        },
        {
          'Style': 'Style No.2',
          'Models': ['FH-10F1', 'FH-10F2'],
          'Inlet/Outlet Thread': 'Plastic, brass insert',
          'Port Sizes': ['1/2"', '3/4"', '1"']
        },
        {
          'Style': 'Style No.3',
          'Models': ['FH-10D1', 'FH-10D2', 'FH-10E1', 'FH-10E2'],
          'Inlet/Outlet Thread': 'Plastic, brass insert',
          'Port Sizes': ['1/2"', '3/4"', '1"']
        },
        {
          'Style': 'Style No.4',
          'Models': ['FH-20BB', 'FH-10BB', 'FH-20A1', 'FH-20A2'],
          'Inlet/Outlet Thread': 'Plastic, brass insert',
          'Port Sizes': ['1/2"', '3/8"', '3/4"', '1"', '1 1/2"']
        }
      ]
    }
  },
    'household-ss-filter-housing': {
    id: 'household-ss-filter-housing',
    title: 'Household SS Filter Housing',
    name: 'Household SS Filter Housing',
    category: 'Filter Housing',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/6d4eca4ee53c53d4425da54f5a6410f8.png',
    shortDescription: 'Household stainless steel filter housings in multiple styles; stainless construction, high pressure and corrosion resistant for hot & cold water filtration.',
    description: 'Household Stainless Steel Filter Housing — multiple styles for residential hot & cold water filtration.',
    longDescription: `Household Stainless Steel Filter Housing designed for domestic and light commercial hot & cold water filtration. Manufactured from superfine stainless steel for excellent corrosion resistance and high pressure capability. Available in multiple styles (Style No.1 to No.3) with various inlet/outlet thread options and port sizes.

Technical specifications:
- Max. Pressure: 10 Bar (145psi)
- Recommended Pressure: < 8 Bar (115psi) at 25°C
- Max. Temperature: 125°C

Suitable for drinking water systems, hot water filtration, RO pre-filtration, and general household water treatment.`,
    features: [
      'Superfine stainless steel construction',
      'High pressure and corrosion resistant',
      'Suitable for hot and cold water filtration',
      'Multiple styles with various thread and port size options',
      'Durable design for household and light commercial use'
    ],
    applications: [
      'Domestic water filtration',
      'Hot & cold water systems',
      'RO pre-filtration',
      'Small commercial water filtration'
    ],
    specifications: {
      'Housing Material': 'Stainless Steel',
      'Max Pressure': '10 Bar (145psi)',
      'Recommended Pressure': '< 8 Bar (115psi) at 25°C',
      'Max Temperature': '125°C'
    },
    technicalData: {
      'Styles & Models': [
        {
          'Style': 'Style No.1',
          'Thread Type': 'Brass insert',
          'Port Sizes': ['1/2"', '3/4"', '1"'],
          'Notes': 'Compact household models; brass insert threads'
        },
        {
          'Style': 'Style No.2',
          'Thread Type': 'Stainless steel',
          'Port Sizes': ['1/2"', '3/4"', '1"'],
          'Notes': 'Stainless thread for improved corrosion resistance'
        },
        {
          'Style': 'Style No.3',
          'Thread Type': 'Stainless steel',
          'Port Sizes': ['3/4"', '1"', '1.5"'],
          'Notes': 'Larger-capacity models for higher flow / hot water use'
        }
      ]
    }
  },
    'ss-sanitary-filter-housing-in-line-style': {
    id: 'ss-sanitary-filter-housing-in-line-style',
    title: 'SS Sanitary Filter Housing In-line Style',
    name: 'SS Sanitary Filter Housing In-line Style',
    category: 'Filter Housing',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/8396080c1e2b945c28fe7c9abe95187c.png',
    shortDescription: 'Sanitary in-line stainless steel filter housing for hygienic processing; V-clamp cover, 222/226 O-ring adaptors, max 125psi.',
    description: 'Sanitary in-line style stainless steel filter housing suitable for hygienic and sanitary applications.',
    longDescription: `Sanitary in-line style filter housing constructed from high-quality Stainless Steel 304# or 316L for hygienic processing. Designed for sanitary industries including food & beverage, pharmaceutical, biotech and beverage production. Features V-clamp hinged cover for quick access and 222/226 O-ring adaptors to accept standard sanitary filter elements.

Introduction & datasheet: https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/498e0c4aa5aea015101fb9ef990c607c.png
Material: Stainless Steel 304# or 316L.
Filter element adaptors: 222 O-ring, 226 O-ring.
Cover opening & closure type: V-clamp hinged.
Max. Pressure: 125psi.`,
    features: [
      'Material: Stainless Steel 304# or 316L',
      'Sanitary in-line design',
      'Cover opening & closure type: V-clamp hinged',
      'Filter element adaptors: 222 O-ring, 226 O-ring',
      'Max Pressure: 125psi',
      'Suitable for food, beverage, pharmaceutical and biotech applications'
    ],
    applications: [
      'Food and beverage processing',
      'Pharmaceutical manufacturing',
      'Biotech processes',
      'Sanitary water and beverage filtration',
      'RO pre-filtration in hygienic systems'
    ],
    specifications: {
      'Housing Material': 'Stainless Steel 304#, 316L',
      'Filter Adaptors': '222 O-ring, 226 O-ring',
      'Closure Type': 'V-clamp hinged',
      'Max Pressure': '125psi',
      'Style': 'In-line'
    },
    technicalData: {
      'Model Specifications': [
        { 'Model': '1 Round - 5\"L',  'A mm': '233', 'Inlet/Outlet': '1\" TC' },
        { 'Model': '1 Round - 10\"L', 'A mm': '360', 'Inlet/Outlet': '1\" TC' },
        { 'Model': '1 Round - 20\"L', 'A mm': '614', 'Inlet/Outlet': '1\" TC' }
      ]
    }
  },
    'ss-sanitary-lenticular-disc-stack-filter-housing-slf': {
    id: 'ss-sanitary-lenticular-disc-stack-filter-housing-slf',
    title: 'SS Sanitary Lenticular Disc Stack Filter Housing SLF',
    name: 'SS Sanitary Lenticular Disc Stack Filter Housing SLF',
    category: 'Filter Housing',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/f1fa54fa5e2160a412e82affcb92e7c7.png',
    shortDescription: 'Sanitary lenticular disc stack filter housing (SLF series) for high-efficiency particulate removal; swing-bolt closure, stainless steel 304/316L, max 150psi.',
    description: 'Sanitary lenticular disc stack filter housing — SLF Series for hygienic processing and high-capacity filtration.',
    longDescription: `SLF Series sanitary lenticular disc stack filter housings are designed for hygienic and sanitary processing where high-efficiency filtration and cleanability are required. Constructed from high-quality Stainless Steel 304# or 316L, the housings feature a swing-bolt hinged cover for secure closure and easy access. Two lenticular disc diameters are available for different performance and cell counts.

Datasheets / introduction:
- https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/1ac532cb7986c55f1de7cc244ce6c7d1.png
- https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/7df00583850394d0145313147ad85d6b.png

Material: Stainless Steel 304# or 316L.
Cover opening & closure type: Swing bolt hinged.
Max. Pressure: 150psi.
Suitable for food & beverage, pharmaceutical, biotech, beverage production and other sanitary applications.`,
    features: [
      'Material: Stainless Steel 304# or 316L',
      'Lenticular disc stack design for high-efficiency filtration',
      'Swing bolt hinged cover for secure closure and easy access',
      'Sanitary construction suitable for hygienic processes',
      'Max Pressure: 150psi'
    ],
    applications: [
      'Food and beverage processing',
      'Pharmaceutical manufacturing',
      'Biotech processes',
      'Beverage production',
      'Sanitary water filtration'
    ],
    specifications: {
      'Housing Material': 'Stainless Steel 304#, 316L',
      'Closure Type': 'Swing bolt hinged',
      'Max Pressure': '150psi',
      'Filter Type': 'Lenticular disc stack'
    },
    technicalData: {
      '01 - 0285 - Series (Lenticular Disc Stack Dia.11 - 1/8\" (28.3mm))': [
        { 'Model': '01 - 0285 - 1',  'A Dimension': '19 - 3/8\" (492mm)',  'Cells#': '16' },
        { 'Model': '01 - 0285 - 2SP', 'A Dimension': '27\" (686mm)',        'Cells#': '25' },
        { 'Model': '01 - 0285 - 2',  'A Dimension': '30 - 3/8\" (772mm)',  'Cells#': '32' },
        { 'Model': '01 - 0285 - 3',  'A Dimension': '43 - 1/8\" (1051mm)', 'Cells#': '64' },
        { 'Model': '01 - 0285 - 4',  'A Dimension': '52 - 3/8\" (1330mm)', 'Cells#': '48' }
      ],
      '01 - 0295 - Series (Lenticular Disc Stack Dia.16 - 3/4\" (42.5mm))': [
        { 'Model': '01 - 0295 - 1', 'A Dimension': '20\" (508mm)',        'Cells#': '14' },
        { 'Model': '01 - 0295 - 2', 'A Dimension': '32\" (813mm)',        'Cells#': '28' },
        { 'Model': '01 - 0295 - 3', 'A Dimension': '43 - 1/8\" (1096mm)', 'Cells#': '42' },
        { 'Model': '01 - 0295 - 4', 'A Dimension': '52 - 1/2\" (1394mm)', 'Cells#': '56' }
      ]
    }
  },
    'ss-sanitary-ventilator-filter-housing': {
    id: 'ss-sanitary-ventilator-filter-housing',
    title: 'SS Sanitary Ventilator Filter Housing',
    name: 'SS Sanitary Ventilator Filter Housing',
    category: 'Filter Housing',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/e81936c2e8b2ab44f3802772fa7a3c95.png',
    shortDescription: 'Sanitary stainless steel ventilator / breather filter housing for tanks and vessels; hygienic design, durable SS304/316L construction.',
    description: 'Sanitary Ventilator Filter Housing for breather and vent filtration in hygienic processing systems.',
    longDescription: `Sanitary ventilator (breather) filter housing designed for hygienic tank venting and vessel protection. Constructed from high-quality Stainless Steel 304# or 316L for corrosion resistance and sanitary compatibility. The housing provides reliable particulate and microbial control for vents and breathers on storage tanks, mixers, and vessels in food, beverage, pharmaceutical and biotech facilities. Available with hygienic connections and service-friendly closures for easy inspection and element replacement. Consult factory for specific connection types, element options and pressure ratings.`,
    features: [
      'Material: Stainless Steel 304# or 316L',
      'Hygienic sanitary design for tank venting and breather applications',
      'Suitable for particulate and vent filtration',
      'Service-friendly closure for easy element replacement',
      'Available with multiple connection options (tri-clamp, threaded, flanged)',
      'Durable corrosion-resistant construction'
    ],
    applications: [
      'Tank and vessel venting (breather filters)',
      'Food & beverage processing',
      'Pharmaceutical manufacturing',
      'Biotech and sanitary production',
      'Storage tanks, mixers and reactors'
    ],
    specifications: {
      'Housing Material': 'Stainless Steel 304#, 316L',
      'Typical Connections': 'Tri-clamp / threaded / flanged (optional)',
      'Max Pressure': '150psi (consult factory)',
      'Suitable Elements': 'Breather cartridges, pleated or sintered elements',
      'Surface Finish': 'Polished or sanitary finish (option)'
    },
    technicalData: {
      'Model Specifications': []
    }
  },
    'ss-sanitary-multi-cartridge-filter-housing-scf-2': {
    id: 'ss-sanitary-multi-cartridge-filter-housing-scf-2',
    title: 'SS Sanitary Multi Cartridge Style Filter Housing SCF-2',
    name: 'SS Sanitary Multi Cartridge Style Filter Housing SCF-2',
    category: 'Filter Housing',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/b972af0e6729e202307befe8824ba399.png',
    shortDescription: 'Sanitary multi-cartridge stainless steel filter housing (SCF-2 series) for high-capacity hygienic filtration; swing-bolt cover, 222/226 O-ring adaptors, max 150psi.',
    description: 'SCF-2 Series multi-cartridge sanitary stainless steel filter housings for food, beverage, pharmaceutical and biotech applications.',
    longDescription: `SCF-2 Series multi-cartridge sanitary filter housings are engineered for hygienic, high-capacity cartridge filtration in food, beverage, pharmaceutical and biotech industries. Constructed from high-quality Stainless Steel 304# or 316L and featuring a swing-bolt hinged cover, these housings accept standard sanitary cartridge adaptors (222 or 226 O-ring). The robust design supports high pressure operation up to 150psi and provides easy access for cartridge replacement and cleaning.

Introduction & datasheet: https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/9fd1452a9e06491b5018e104d97688d0.png
Material: Stainless Steel 304# or 316L.
Filter element adaptors: 222 O-ring, 226 O-ring.
Cover opening & closure type: Swing bolt hinged.
Max. Pressure: 150psi.`,
    features: [
      'Material: Stainless Steel 304# or 316L',
      'Multi-cartridge design for high flow and capacity',
      'Swing bolt hinged cover for secure closure and easy access',
      'Filter adaptors: 222 O-ring, 226 O-ring',
      'Max Pressure: 150psi',
      'Sanitary construction suitable for hygienic processing'
    ],
    applications: [
      'Food and beverage processing',
      'Pharmaceutical manufacturing',
      'Biotech processes',
      'Beverage production',
      'Sanitary water filtration and RO pre-filtration'
    ],
    specifications: {
      'Housing Material': 'Stainless Steel 304#, 316L',
      'Filter Adaptors': '222 O-ring, 226 O-ring',
      'Closure Type': 'Swing bolt hinged',
      'Max Pressure': '150psi',
      'Surface Finish': 'Polished or sanitary finish (option)'
    },
    technicalData: {
      'Model Specifications': [
        { 'Model': '3 Round - 10\"L',  'A mm': '150', 'B mm': '125', 'C mm': '420',  'D mm': '200', 'F mm': '340', 'Inlet/Outlet': '1\" TC' },
        { 'Model': '3 Round - 20\"L',  'A mm': '150', 'B mm': '125', 'C mm': '670',  'D mm': '200', 'F mm': '340', 'Inlet/Outlet': '1\" TC' },
        { 'Model': '3 Round - 30\"L',  'A mm': '150', 'B mm': '125', 'C mm': '920',  'D mm': '200', 'F mm': '340', 'Inlet/Outlet': '1 1/2\" TC' },
        { 'Model': '3 Round - 40\"L',  'A mm': '150', 'B mm': '125', 'C mm': '1170', 'D mm': '200', 'F mm': '340', 'Inlet/Outlet': '2\" TC' },

        { 'Model': '5 Round - 10\"L',  'A mm': '150', 'B mm': '150', 'C mm': '420',  'D mm': '220', 'F mm': '340', 'Inlet/Outlet': '1 1/2\" TC' },
        { 'Model': '5 Round - 20\"L',  'A mm': '150', 'B mm': '150', 'C mm': '670',  'D mm': '220', 'F mm': '340', 'Inlet/Outlet': '1 1/2\" TC' },
        { 'Model': '5 Round - 30\"L',  'A mm': '150', 'B mm': '150', 'C mm': '920',  'D mm': '220', 'F mm': '340', 'Inlet/Outlet': '2\" TC' },
        { 'Model': '5 Round - 40\"L',  'A mm': '150', 'B mm': '150', 'C mm': '1170', 'D mm': '220', 'F mm': '340', 'Inlet/Outlet': '2\" TC' },

        { 'Model': '7 Round - 20\"L',  'A mm': '225', 'B mm': '150', 'C mm': '670',  'D mm': '250', 'F mm': '340', 'Inlet/Outlet': '2\" TC' },
        { 'Model': '7 Round - 30\"L',  'A mm': '225', 'B mm': '150', 'C mm': '920',  'D mm': '250', 'F mm': '340', 'Inlet/Outlet': '2\" TC' },
        { 'Model': '7 Round - 40\"L',  'A mm': '225', 'B mm': '150', 'C mm': '1170', 'D mm': '250', 'F mm': '340', 'Inlet/Outlet': '2\" TC' },

        { 'Model': '9 Round - 30\"L',  'A mm': '225', 'B mm': '210', 'C mm': '920',  'D mm': '300', 'F mm': '450', 'Inlet/Outlet': '2\" TC' },
        { 'Model': '9 Round - 40\"L',  'A mm': '225', 'B mm': '210', 'C mm': '1170', 'D mm': '300', 'F mm': '450', 'Inlet/Outlet': '2 1/2\" TC' },

        { 'Model': '12 Round - 30\"L', 'A mm': '225', 'B mm': '210', 'C mm': '920',  'D mm': '350', 'F mm': '450', 'Inlet/Outlet': '2 1/2\" TC' },
        { 'Model': '12 Round - 40\"L', 'A mm': '225', 'B mm': '210', 'C mm': '1170', 'D mm': '350', 'F mm': '450', 'Inlet/Outlet': '3\" TC' }
      ]
    }
  },
    'ss-sanitary-single-cartridge-filter-housing-scf-1': {
    id: 'ss-sanitary-single-cartridge-filter-housing-scf-1',
    title: 'SS Sanitary Single Cartridge Style Filter Housing SCF-1',
    name: 'SS Sanitary Single Cartridge Style Filter Housing SCF-1',
    category: 'Filter Housing',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/9187cb4c4a035e022752a3dbc6cab923.png',
    shortDescription: 'Sanitary single-cartridge stainless steel filter housing (SCF-1 series) for hygienic applications; V-clamp cover, 222/226 O-ring adaptors, max 125psi.',
    description: 'SCF-1 Series single-cartridge sanitary stainless steel filter housing for food, beverage, pharmaceutical and biotech applications.',
    longDescription: `SCF-1 Series sanitary single-cartridge filter housings are constructed from high-quality Stainless Steel 304# or 316L and designed for hygienic processing. They accept standard sanitary cartridge adaptors (222 or 226 O-ring) and feature a V-clamp hinged cover for quick access and secure closure. Suitable for food & beverage, pharmaceutical and biotech industries where sanitary design and easy maintenance are required.

Introduction & datasheet: https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/8e34a20126fff3ec65c7879bf5c3c354.png
Material: Stainless Steel 304# or 316L.
Filter element adaptors: 222 O-ring, 226 O-ring.
Cover opening & closure type: V-clamp hinged.
Max. Pressure: 125psi.`,
    features: [
      'Material: Stainless Steel 304# or 316L',
      'Sanitary single-cartridge design',
      'V-clamp hinged cover for quick access',
      'Filter adaptors: 222 O-ring, 226 O-ring',
      'Max Pressure: 125psi',
      'Polished / sanitary finish options'
    ],
    applications: [
      'Food and beverage processing',
      'Pharmaceutical manufacturing',
      'Biotech processes',
      'Sanitary water and beverage filtration',
      'RO pre-filtration in hygienic systems'
    ],
    specifications: {
      'Housing Material': 'Stainless Steel 304#, 316L',
      'Filter Adaptors': '222 O-ring, 226 O-ring',
      'Closure Type': 'V-clamp hinged',
      'Max Pressure': '125psi',
      'Surface Finish': 'Polished / sanitary finish (option)'
    },
    technicalData: {
      'Model Specifications': [
        { 'Model': '1 Round - 10\"L', 'A mm': '85',  'B mm': '165', 'C mm': '560',  'D mm': '102', 'F mm': '200', 'Inlet/Outlet': '1/2\" - 1\" TC' },
        { 'Model': '1 Round - 20\"L', 'A mm': '85',  'B mm': '165', 'C mm': '810',  'D mm': '102', 'F mm': '200', 'Inlet/Outlet': '1/2\" - 1\" TC' },
        { 'Model': '1 Round - 30\"L', 'A mm': '85',  'B mm': '165', 'C mm': '1060', 'D mm': '102', 'F mm': '200', 'Inlet/Outlet': '1/2\" - 1\" TC' }
      ]
    }
  }
};

export const filterHousingProductsList = [
  {
    id: 'upvc-cartridge-filter-housing',
    name: 'UPVC Cartridge Style Filter Housing',
    category: 'Filter Housing',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/381587b708494aac3fe75e979c5879c5.png',
    shortDescription: 'High-precision UPVC cartridge filter housing for pretreatment and various purification applications.',
    description: 'HPCF cartridge filter is a high-precision system consisting of a housing and cartridge elements, mainly used in pretreatment for various industries.',
    features: [
      'High precision filter system',
      'Made from durable UPVC material',
      'Installs 5, 8, or 9 cartridges'
    ],
    applications: [
      'Pure water treatment',
      'Sewage treatment',
      'Food & Beverage'
    ]
  },
  {
    id: 'upvc-bag-style-filter-housing',
    name: 'UPVC Bag Style Filter Housing',
    category: 'Filter Housing',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/83ca33c40581e3462acceed8f4ceaf1d.png',
    shortDescription: 'High precision, big flow UPVC bag filter system for various liquid treatment applications.',
    description: 'A new filter system with high precision, big flow, easy installation and maintenance, widely used in liquid treatment.',
    features: [
      'High precision filtration',
      'High flow rate',
      'Easy installation and maintenance'
    ],
    applications: [
      'Foods',
      'Cosmetic',
      'Chemistry'
    ]
  },
  {
    id: 'ss-ultra-highflow-cartridge-filter-housing',
    name: 'SS Ultra Highflow Cartridge Filter Housing',
    category: 'Filter Housing',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/d29cd93ad166a272bea6e7bf3929d965.jpg',
    shortDescription: 'Heavy-duty stainless steel housing for ultra highflow cartridges with swing bolt closure.',
    description: 'The HCFH-SERIES is a robust stainless steel filter housing designed for high-flow applications.',
    features: [
        'Material: Stainless Steel 304# or 316L',
        'Swing bolt hinged closure',
        'Max. pressure: 150psi'
    ],
    applications: [
        'Industrial water treatment',
        'Chemical processing',
        'Food and beverage'
    ]
  },
  {
    id: 'ss-cartridge-style-filter-housing-cfh-3',
    name: 'SS Cartridge Style Filter Housing CFH-3',
    category: 'Filter Housing',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/3a39b1a5fd337868181b66e8310fdea4.png',
    shortDescription: 'Industrial stainless steel filter housing with swing bolt closure and lifting davit for heavy-duty applications.',
    description: 'The CFH-3 Series is an industrial-grade stainless steel cartridge filter housing with a lifting davit for easy maintenance.',
    features: [
      'Material: Stainless steel 304# or 316L',
      'Closure: Swing bolt hinged with lifting davit',
      'Max. pressure: 150psi'
    ],
    applications: [
      'Industrial water treatment',
      'Chemical Processing',
      'Food and Beverage'
    ]
  },
  {
    id: 'ss-cartridge-style-filter-housing-cfh-2',
    name: 'SS Cartridge Style Filter Housing CFH-2',
    category: 'Filter Housing',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/778313498601fa73d02b1640fa48b800.png',
    shortDescription: 'Industrial stainless steel housing (CFH-2 series) for cartridge filters with a swing bolt closure.',
    description: 'The CFH-2 Series is a durable stainless steel cartridge filter housing with a swing bolt closure for industrial filtration.',
    features: [
      'Material: Stainless steel 304# or 316L',
      'Closure: Swing bolt hinged',
      'Max. pressure: 150psi'
    ],
    applications: [
      'Industrial water treatment',
      'Chemical Processing',
      'Food and Beverage'
    ]
  },
  {
    id: 'ss-cartridge-style-filter-housing-cfh-1',
    name: 'SS Cartridge Style Filter Housing CFH-1',
    category: 'Filter Housing',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/77a09ce56b225e6e6efafb9a9beea747.jpg',
    shortDescription: 'Light-duty stainless steel housing (CFH-1 series) for cartridge filters with a V-clamp closure.',
    description: 'The CFH-1 Series is a stainless steel cartridge filter housing with a V-clamp closure, ideal for light industrial and commercial filtration.',
    features: [
      'Material: Stainless steel 304# or 316L',
      'Closure: V-clamp hinged',
      'Max. pressure: 100psi'
    ],
    applications: [
      'General water filtration',
      'RO Pre-filtration',
      'Food and Beverage'
    ]
  },
    {
    id: 'ss-single-bag-style-filter-housing-sbf-2',
    name: 'SS Single Bag Style Filter Housing SBF-2',
    category: 'Filter Housing',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/5dd111ce87360dabf22cdc87f38c720c.png',
    shortDescription: 'Stainless steel single-bag filter housing (SBF-2 series) for industrial liquid treatment; swing-bolt cover, max 150psi.',
    description: 'Stainless Steel Industry Bag Style Filter Housing — SBF-2 Series (Single Bag).',
    features: [
      'Material: Stainless Steel 304# or 316L',
      'Single bag configuration',
      'Swing bolt hinged cover',
      'Max Pressure: 150psi'
    ],
    applications: [
      'Industrial water treatment',
      'Chemical processing',
      'Food and Beverage'
    ]
  },
    {
    id: 'ss-single-bag-style-filter-housing-sbf-1',
    name: 'SS Single Bag Style Filter Housing SBF-1',
    category: 'Filter Housing',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/db31dc436950b6d90c726517bbb5ef7d.png',
    shortDescription: 'Stainless steel single-bag filter housing (SBF-1 series) for industrial liquid treatment; V-clamp hinged cover, max 100psi.',
    description: 'Stainless Steel Industry Bag Style Filter Housing — SBF-1 Series (Single Bag).',
    features: [
      'Material: Stainless Steel 304# or 316L',
      'Single bag configuration',
      'V-clamp hinged cover',
      'Max Pressure: 100psi'
    ],
    applications: [
      'Industrial water treatment',
      'Chemical processing',
      'Food and Beverage'
    ]
  },
    {
    id: 'ss-multi-bag-style-filter-housing-mbf',
    name: 'SS Multi Bag Style Filter Housing MBF',
    category: 'Filter Housing',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/c47d87df9b1837948cecdcc6a3c6fce3.png',
    shortDescription: 'Stainless steel multi-bag filter housing (MBF series) for high-flow industrial liquid treatment; swing-bolt cover with lifting davit, max 150psi.',
    description: 'Stainless Steel Industry Bag Style Filter Housing — MBF Series (Multi Bag).',
    features: [
      'Material: Stainless Steel 304# or 316L',
      'Multi-bag configuration for high flow',
      'Swing bolt hinged cover with lifting davit',
      'Max Pressure: 150psi'
    ],
    applications: [
      'Industrial water treatment',
      'Chemical processing',
      'Food and Beverage'
    ]
  },
    {
    id: 'household-plastic-filter-housing',
    name: 'Household Plastic Filter Housing',
    category: 'Filter Housing',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/cecb80a7bc5bc594b571fbcacd83a479.png',
    shortDescription: 'Household plastic filter housings in multiple styles; PP/AS materials, various port sizes, and optional features.',
    description: 'Household Plastic Filter Housing — available in Style No.1 to No.4 with multiple model options and port sizes.',
    features: [
      'PP and AS materials (FDA compliant)',
      'Thicker ribbed housing for higher pressure resistance',
      'Options: opener, air release button, brass thread insert',
      'Multiple port sizes'
    ],
    applications: [
      'Domestic water filtration',
      'RO pre-filtration',
      'Small commercial filtration'
    ]
  },
    {
    id: 'household-ss-filter-housing',
    name: 'Household SS Filter Housing',
    category: 'Filter Housing',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/6d4eca4ee53c53d4425da54f5a6410f8.png',
    shortDescription: 'Household stainless steel filter housings; high pressure and corrosion resistant for hot & cold water filtration. Multiple styles and port sizes available.',
    description: 'Household Stainless Steel Filter Housing — suitable for domestic hot & cold water applications.',
    features: [
      'Superfine stainless steel material',
      'High pressure & corrosion resistant',
      'Suitable for hot and cold water filtration'
    ],
    applications: [
      'Domestic water filtration',
      'RO pre-filtration',
      'Hot water systems'
    ]
  },
    {
    id: 'ss-sanitary-filter-housing-in-line-style',
    name: 'SS Sanitary Filter Housing In-line Style',
    category: 'Filter Housing',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/8396080c1e2b945c28fe7c9abe95187c.png',
    shortDescription: 'Sanitary in-line stainless steel filter housing for hygienic processing; V-clamp cover, 222/226 O-ring adaptors, max 125psi.',
    description: 'Sanitary in-line style stainless steel filter housing suitable for hygienic and sanitary applications.',
    features: [
      'Material: Stainless Steel 304# or 316L',
      'Sanitary in-line design',
      'V-clamp hinged cover',
      '222 and 226 O-ring adaptors',
      'Max Pressure: 125psi'
    ],
    applications: [
      'Food & Beverage',
      'Pharmaceuticals',
      'Biotech',
      'Sanitary water filtration'
    ]
  },
    {
    id: 'ss-sanitary-lenticular-disc-stack-filter-housing-slf',
    name: 'SS Sanitary Lenticular Disc Stack Filter Housing SLF',
    category: 'Filter Housing',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/f1fa54fa5e2160a412e82affcb92e7c7.png',
    shortDescription: 'Sanitary lenticular disc stack filter housing (SLF series) for hygienic processing; swing-bolt closure, SS 304/316L, max 150psi.',
    description: 'Sanitary lenticular disc stack filter housing — SLF Series for food, beverage, pharmaceutical and biotech applications.',
    features: [
      'Stainless Steel 304# or 316L construction',
      'Lenticular disc stack design',
      'Swing bolt hinged cover',
      'Max Pressure: 150psi'
    ],
    applications: [
      'Food and beverage processing',
      'Pharmaceuticals',
      'Biotech',
      'Sanitary water filtration'
    ]
  },
    {
    id: 'ss-sanitary-ventilator-filter-housing',
    name: 'SS Sanitary Ventilator Filter Housing',
    category: 'Filter Housing',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/e81936c2e8b2ab44f3802772fa7a3c95.png',
    shortDescription: 'Sanitary stainless steel ventilator/breather filter housing for tanks and vessels; hygienic design and SS304/316L construction.',
    description: 'Sanitary Ventilator Filter Housing — designed for breather and vent filtration in hygienic processing.',
    features: [
      'Stainless Steel 304# or 316L',
      'Hygienic design for tank vents',
      'Multiple connection options',
      'Easy service and element replacement'
    ],
    applications: [
      'Tank venting and breather filtration',
      'Food & Beverage',
      'Pharmaceuticals',
      'Biotech'
    ]
  },
    {
    id: 'ss-sanitary-multi-cartridge-filter-housing-scf-2',
    name: 'SS Sanitary Multi Cartridge Style Filter Housing SCF-2',
    category: 'Filter Housing',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/b972af0e6729e202307befe8824ba399.png',
    shortDescription: 'Sanitary multi-cartridge stainless steel filter housing (SCF-2 series) for high-capacity hygienic filtration; swing-bolt cover, 222/226 O-ring adaptors, max 150psi.',
    description: 'SCF-2 Series multi-cartridge sanitary stainless steel filter housings for food, beverage, pharmaceutical and biotech applications.',
    features: [
      'Stainless Steel 304# or 316L',
      'Multi-cartridge design for high flow',
      'Swing bolt hinged cover',
      '222 and 226 O-ring adaptors',
      'Max Pressure: 150psi'
    ],
    applications: [
      'Food & Beverage',
      'Pharmaceuticals',
      'Biotech',
      'Sanitary water filtration'
    ]
  },
    {
    id: 'ss-sanitary-single-cartridge-filter-housing-scf-1',
    name: 'SS Sanitary Single Cartridge Style Filter Housing SCF-1',
    category: 'Filter Housing',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/9187cb4c4a035e022752a3dbc6cab923.png',
    shortDescription: 'Sanitary single-cartridge stainless steel filter housing (SCF-1 series); V-clamp cover, 222/226 O-ring adaptors, max 125psi.',
    description: 'SCF-1 Series single-cartridge sanitary stainless steel filter housing for hygienic processing and easy maintenance.',
    features: [
      'Stainless Steel 304# or 316L',
      'Sanitary single-cartridge design',
      'V-clamp hinged cover',
      '222 and 226 O-ring adaptors',
      'Max Pressure: 125psi'
    ],
    applications: [
      'Food & Beverage',
      'Pharmaceuticals',
      'Biotech',
      'Sanitary water filtration'
    ]
  }
];

export default filterHousingProducts;